// Internal dependencies
import { Document, autoSave } from './Document';
import { Editor } from './Editor';
import { Documents, createDocument } from './Documents';
export { Editor, Document, autoSave, Documents, createDocument, };
